module.exports = __webpack_public_path__ + "static/media/logotipo-autocorp.50576961.svg";